import styled from "styled-components";
import { sharedGap } from "../../styles";

export const StyledFlexWrapper = styled.div<{ $marginBottom?: number }>`
  display: flex;
  gap: ${sharedGap};
  flex-wrap: wrap;
  justify-content: center;

  ${({ $marginBottom }) => ($marginBottom ? `margin-bottom: ${$marginBottom}px;` : "")}
`;
StyledFlexWrapper.displayName = "StyledFlexWrapper";

export const StyledFormItemContainer = styled.div`
  width: 100%;
  max-width: 200px;
`;
StyledFormItemContainer.displayName = "StyledFormItemContainer";
